import {  createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { api, sendAsync } from "../../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../../app/store";
import * as service from "../../../services/drugStatic";
import { drugStaticParams } from "../../../services/drugStatic";

interface DrugStatic {
  DrugStaticData: [],
  Total: 0,
  Current: 1,
}

const initialState  = {
  DrugStaticData: [],
  Total: 0,
  Current: 1,


}as DrugStatic;

const drugStaticSlice = createSlice({
  name: "drugStaticSlice",
  initialState,
  reducers: {
    setData(state, action) {
      state.DrugStaticData = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
 

  },
});

export const { setData, setTotal,setCurrent, } = drugStaticSlice.actions;

  export const selectDrugStaticData = (state: RootState) => state.drugStatic.DrugStaticData

  export const selectTotal = (state: RootState) => state.drugStatic.Total
  
  export const selectCurrent = (state: RootState) => state.drugStatic.Current
  
  



export function getDrugStaticList(params: drugStaticParams): RootThunk {
  return api(service.getDrugStaticList(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
    dispatch(setTotal(data.total))
  });
}

// export const getDoctorAuditExoprt = createAsyncThunk<
//   void,
//   drugStaticParams,
//   RootThunkApi
// >("doctorAudit/getDoctorAuditExoprt ", async (params, api) => {
//   return sendAsync(getDoctorAuditExport(params), api);
// });


export default drugStaticSlice.reducer;
